import { Model } from '@/models/Model';

export class Set extends Model {
  protected $name: string = 'Set';
  protected $endpoint: string = '/orders/{id}/relationships/sets';
  protected $fillable: string[] = [
    'id',
    'name',
    'text',
  ];

  public name?: string;
  public product?: Product;
  public text?: string;

  public order(order: Model | string) {
    this.$endpoint = `/orders/${order}/relationships/sets`;

    return this;
  }

  public orderSet(order: Model | string, set: Model | string) {
    this.$endpoint = `/orders/${order}/relationships/sets/${set}`;

    return this;
  }

  public updateOrderSet(orderId: string, id: string, payload: object) {
    const url = `/orders/${orderId}/relationships/sets/${id}`;
    return this.request('patch', url, payload);
  }

  deleteOrderSet(orderId: string, id: string) {
    const url = `/orders/${orderId}/relationships/sets/${id}`;
    return this.request('delete', url);
  }

  public resolvePrimaryKey(): string {
    return '';
  }
}

interface Product {
  name?: string;
  id?: string;
}
